import React, { useState } from "react";
import { Form, Input } from "antd";
import toast from "react-hot-toast";
import "../styles/LoginStyles.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");

  const handleReset = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/forgot-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const data = await res.json();
      if (data.success) {
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error("Erreur lors de l'envoi du lien");
    }
  };

  return (
    <div className="form-wrapper">
      <div className="login-card">
        <h2 className="form-title">Réinitialisation du mot de passe</h2>
        <Form layout="vertical" onFinish={handleReset} className="form-body">
          <Form.Item label="Email" required>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Entrer votre email"
            />
          </Form.Item>

          <button type="submit" className="btn btn-primary full-width">
            Envoyer le lien
          </button>
        </Form>
      </div>
    </div>
  );
};

export default ForgotPassword;
